import { ClasePerdida } from '../../models/clase-perdida';

/* NgRx */
import { createAction, props } from '@ngrx/store';

export const setIdUnidad = createAction(
  '[ClasePerdida Page] Set Id Unidad',
  props<{ idUnidad: number }>()
);

export const setCurrentClasePerdida = createAction(
  '[ClasePerdida Page] Set Current ClasePerdida',
  props<{ currentClasePerdidaId: number }>()
);

export const clearCurrentClasePerdida = createAction(
  '[ClasePerdida Page] Clear Current ClasePerdida',
);

export const initializeCurrentClasePerdida = createAction(
  '[ClasePerdida Page] Initialize Current ClasePerdida',
);

export const loadClasePerdidas = createAction(
  '[ClasePerdida Page] Load ClasePerdidas',
  props<{ idUnidad: number }>()
);

export const loadUnidadMaterias = createAction(
  '[ClasePerdida Page] Load UnidadMaterias',
  props<{ idUnidad: number }>()
);

export const updateClasePerdida = createAction(
  '[ClasePerdida Page] Update ClasePerdida',
  props<{ clasePerdida: ClasePerdida }>()
);

export const deleteClasePerdida = createAction(
  '[ClasePerdida Page] Delete ClasePerdida',
  props<{ clasePerdida: ClasePerdida }>()
);

export const createClasePerdida = createAction(
  '[ClasePerdida Page] Create ClasePerdida',
  props<{ clasePerdida: ClasePerdida }>()
);
